import { Link } from "react-router-dom";
import "../styles/Home.css";

const Home = () => {
  const focusAreas = [
    {
      id: 1,
      title: "Tech Contracts",
      description:
        "Senior product engineering, architecture reviews, MVP planning, backend/API work, React delivery, and founder-level technical leadership.",
      label: "Available for scoped contracts",
    },
    {
      id: 2,
      title: "Fashion Commissions",
      description:
        "Custom one-of-one garments, upcycled pieces, styling-forward design work, and Both Rows projects built around craft, fit, and story.",
      label: "Open to commissions",
    },
  ];

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <p className="hero-kicker">Tech contracts + fashion commissions</p>
          <h1 className="hero-title">
            <span>Tech leader.</span>
            <span>Fashion designer.</span>
            <span>Builder.</span>
          </h1>
          <p className="hero-text">
            I am a software engineering leader and fashion designer available
            for scoped tech contracts, founder advisory, custom design
            commissions, and project-based creative work. This portfolio is built
            for companies, founders, collaborators, and clients who need to
            quickly understand what I have done and what I can help create.
          </p>
          <div className="hero-actions">
            <Link to="/portfolio#tech" className="primary-link">
              View Tech Resume
            </Link>
            <Link to="/portfolio#fashion" className="secondary-link">
              View Fashion Work
            </Link>
            <a
              href="/Britney_Epps_Contract_Technical_Resume.pdf"
              download
              className="secondary-link"
            >
              Download Resume
            </a>
            <a
              href="https://www.showbothrows.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-link"
            >
              ShowBothRows.com
            </a>
          </div>
        </div>
        <img 
          src="/IMG_5542.jpg" 
          alt="Britney Epps fashion design work" 
          className="hero-image"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </section>

      <section className="focus-strip" aria-label="Current availability">
        {focusAreas.map((area) => (
          <article key={area.id} className="focus-card">
            <span>{area.label}</span>
            <h2>{area.title}</h2>
            <p>{area.description}</p>
          </article>
        ))}
      </section>

      <section className="services">
        <div className="services-copy">
          <p className="section-kicker">Services</p>
          <h2>Need a technical partner, a custom piece, or a creative collaborator?</h2>
          <p>
            My services page separates advisory, implementation support,
            commissions, and workshops so you can quickly find the right next
            step.
          </p>
          <Link to="/services" className="primary-link">
            Explore Services
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
